var map = {
	"./coins-arbitrum.js": "8fb2",
	"./coins-aurora.js": "84e2",
	"./coins-avalanche.js": "99a9",
	"./coins-celo.js": "4409",
	"./coins-ethereum.js": "1981",
	"./coins-fantom.js": "2772",
	"./coins-harmony.js": "7f33",
	"./coins-kava.js": "d8c4",
	"./coins-moonbeam.js": "630b",
	"./coins-optimism.js": "7b0c",
	"./coins-polygon.js": "0147",
	"./coins-xdai.js": "9254"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8385";